import React, { createContext, useState } from "react";
import {
  PageStatusShape,
  SetPageStatusShape,
} from "../../goal_templates/interfaces/componentTypes";

export const useStatus = (
  initialSelections: PageStatusShape
): [PageStatusShape, SetPageStatusShape] => {
  const [values, setValues] = useState(initialSelections);
  return [
    values,
    (dataRef, data) => {
      setValues((values) => ({
        ...values,
        [dataRef]: data,
      }));
    },
  ];
};
